@if (isGuest$ | async) {
  @switch (variant) {
    @case ('profile') {
      <span class="guest-badge-profile">
        <a
          [routerLink]="helpLink"
          class="guest-badge-link"
          aria-label="Guest account. Learn more about roles and permissions."
          #tooltip="matTooltip"
          matTooltip="Learn More"
          matTooltipPosition="above"
        >
          <span class="guest-badge guest-badge--profile" aria-hidden="true">
            <span class="guest-badge__glyph">G</span>
          </span>
        </a>
        <span class="guest-badge-profile__text">
          Guest account. Some features may be limited.
        </span>
      </span>
    }
    @case ('dropdown') {
      <span
        class="guest-badge guest-badge--dropdown"
        role="img"
        aria-label="Guest"
      >
        <span class="guest-badge__glyph" aria-hidden="true">G</span>
      </span>
    }
    @default {
      <span
        class="guest-badge guest-badge--table"
        role="img"
        aria-label="Guest"
        #tooltip="matTooltip"
        matTooltip="Guest"
        matTooltipPosition="above"
      >
        <span class="guest-badge__glyph" aria-hidden="true">G</span>
      </span>
    }
  }
}
